import { render, staticRenderFns } from "./Sample.vue?vue&type=template&id=b39822e8&"
import script from "./Sample.vue?vue&type=script&lang=js&"
export * from "./Sample.vue?vue&type=script&lang=js&"
import style0 from "./Sample.vue?vue&type=style&index=0&id=b39822e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports